export default "__VITE_ASSET__DJFkPGZo__"